const handoverProtocol = {
	name: 'Handover protocol | Handover protocols',
}

export default handoverProtocol
